import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { ArrowLeft } from "lucide-react";

const SIZE_CLASS = {
  md: "max-w-[min(calc(100vw-2rem),32rem)]",
  lg: "max-w-[min(calc(100vw-2rem),42rem)]",
  xl: "max-w-[min(calc(100vw-2rem),48rem)]",
  full: "max-w-[min(calc(100vw-2rem),56rem)]",
};

/**
 * Modale de détail admin — contenu scrollable, titre clair.
 */
export default function AdminDetailDialog({
  open,
  onOpenChange,
  onBack,
  backLabel = "Retour",
  title,
  description,
  children,
  loading = false,
  error = "",
  size = "lg",
  testId,
  contentClassName,
  /** Masque le bandeau titre (accessibilité : titre conservé en sr-only). */
  hideTitle = false,
  /** Barre d’actions fixe entre l’en-tête et le corps scrollable (ex. Modifier / Supprimer). */
  toolbar = null,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange} modal>
      <DialogContent
        data-testid={testId}
        className={cn(
          "flex max-h-[min(92dvh,820px)] flex-col gap-0 overflow-hidden p-0",
          SIZE_CLASS[size] || SIZE_CLASS.lg,
        )}
      >
        {hideTitle ? (
          <DialogTitle className="sr-only">{title || "Détail"}</DialogTitle>
        ) : (
          <DialogHeader className="shrink-0 space-y-1 border-b border-slate-100 px-4 py-4 pr-12 text-left sm:px-6">
            <div className="flex items-start gap-2">
              {onBack ? (
                <Button
                  type="button"
                  variant="ghost"
                  size="sm"
                  className="-ml-2 mt-0.5 h-8 shrink-0 gap-1 px-2 text-slate-600"
                  onClick={onBack}
                  data-testid={testId ? `${testId}-back` : "detail-dialog-back"}
                >
                  <ArrowLeft className="h-4 w-4" aria-hidden />
                  <span className="text-xs font-medium">{backLabel}</span>
                </Button>
              ) : null}
              <div className="min-w-0 flex-1">
                <DialogTitle className="font-display text-lg font-bold tracking-tight text-slate-900 sm:text-xl">
                  {title}
                </DialogTitle>
                {description ? (
                  <DialogDescription className="text-sm text-slate-600">{description}</DialogDescription>
                ) : null}
              </div>
            </div>
          </DialogHeader>
        )}
        {toolbar ? (
          <div className="shrink-0 border-b border-slate-100 bg-slate-50/80 px-4 py-3 pr-12 sm:px-6 sm:pr-14">
            {toolbar}
          </div>
        ) : null}
        <div
          className={cn(
            "min-h-0 min-w-0 flex-1 overflow-x-hidden overflow-y-auto overscroll-contain px-4 py-4 sm:px-6 sm:py-5",
            contentClassName,
          )}
        >
          {loading ? (
            <p className="py-12 text-center text-sm text-slate-500">Chargement…</p>
          ) : error ? (
            <p className="py-8 text-center text-sm text-red-700">{error}</p>
          ) : (
            children
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
